<template>
	<EMCoreTemplate category="OSMLife" identity="pendingOperation" entity="osm_pending_operations"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementLife/containers/PendingOperation.vue